/* eslint-disable no-console */
export const consoleLog = (value, type) => {
  if (type === "error") {
    console.error(value);
  } else {
    console.log(value);
  }
};
